module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "config"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('label', {
    attrs: {
      "for": "user"
    }
  }, [_vm._v("Host")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.host),
      expression: "host"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "host"
    },
    domProps: {
      "value": (_vm.host)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.host = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('label', {
    attrs: {
      "for": "user"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user),
      expression: "user"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user"
    },
    domProps: {
      "value": (_vm.user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-auto"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateConfig()
      }
    }
  }, [_vm._v("Update")])])]), _vm._v(" "), _c('hr')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c206e28"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiConfig.vue
// module id = 22
// module chunks = 0